var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-success mb-2",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"mdi mdi-plus mr-2"}),_vm._v(" Update ")])
}
var staticRenderFns = []

export { render, staticRenderFns }